import request from '@/router/axios'

/**
 * 获取需求大厅列表
 * @author Shawn Fenng
 * @Date 2019-11-06
 * @param arguments
 */
export function getRequirementList(data) {
  return request({
    url: "/api/business/portal/requirement/list",
    method: "post",
    data: data
  })
}

/**
 * 获取需求详情
 * @author Shawn Fenng
 * @Date 2019-11-06
 * @param arguments
 */
export function getRequirementInfo(id) {
  return request({
    url: "/api/business/portal/requirement/detail/" + id,
    method: "get"
  })
}

/**
 * 获取需求推荐列表
 * @author Shawn Fenng
 * @Date 2019-11-06
 * @param arguments
 */
export function getRecommendRequirementList() {
  return request({
    url: "/api/business/portal/requirement/recommend",
    method: "get"
  })
}

/**
 * 保存需求申请记录
 * @author Shawn Fenng
 * @Date 2019-11-06
 * @param arguments
 */
export function saveApplyRecord(applyRecord) {
  return request({
    url: "/api/business/portal/apply/add",
    method: "post",
    data: applyRecord
  })
}

/**
 * 检查接包商是否申请过指定需求 @Deprecated
 * @author Shawn Fenng
 * @Date 2019-11-06
 * @param arguments
 */
export function checkApplyRecord(requirementId) {
  return request({
    url: "/api/business/portal/apply/check/" + requirementId,
    method: "get"
  })
}

/**
 * 获取接包商申请记录的审核状态
 * @author Shawn Fenng
 * @Date 2019-12-12
 * @param arguments
 */
export function getApplyRecordStatus(requirementId) {
  return request ({
    url: "/api/business/portal/recordStatus/" + requirementId,
    method: "get"
  })
}

/**
 * 检查当前登录接包企业是否通过审核
 * @author Shawn Fenng
 * @Date 2019-12-12
 * @param arguments
 */
export function checkSupplierStatus() {
  return request({
    url: "/api/business/portal/apply/checkSupplierStatus",
    method: "get"
  })
}

/**
 * 更新指定需求的浏览次数
 * @author Shawn Fenng
 * @Date 2019-11-08
 * @param id
 */
export function updateRequirementClicks(id) {
  return request({
    url: "/api/business/portal/requirement/click/" + id,
    method: "get"
  })
}